import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
} from '@mui/material';


import UserAdminClientContext from "../contexts/UserAdminClientContext"

import Home from "../components/ui/AdminDashboard/Home"
import Suivi from "../components/ui/AdminDashboard/Suivi"
import Progression from "../components/ui/AdminDashboard/Progression"
import Certification from "../components/ui/AdminDashboard/Certification"
import SupportChat from "../components/SupportChat"
import VisiteGuidee from "../components/ui/VisiteGuidee"
import LanguageContext from "../contexts/LanguageContext"

/* ⛔ LES TEXTES DE LA VISITE COTE ADMIN CLIENT.
   Meme regle que cote apprenant : on dit ce que la personne peut FAIRE, en
   une phrase, sans vocabulaire de produit. Quatre entrees de menu, trois
   etapes : la premiere page n'a pas besoin d'etre expliquee, on y est deja.
   ⚠️ A relire par Nawal avant mise en ligne. */
const ETAPES_ADMIN = {
  fr: [
    {
      cible: '[data-visite="admin-suivi"]',
      titre: "Qui avance, et qui décroche",
      texte: "Le suivi vous montre, apprenant par apprenant, où chacun en est. C'est là que vous repérez ceux qu'il faut relancer.",
    },
    {
      cible: '[data-visite="admin-progression"]',
      titre: "Les compétences de votre groupe",
      texte: "La progression donne la vue d'ensemble\u00a0: quelles compétences montent, lesquelles résistent.",
    },
    {
      cible: '[data-visite="admin-certification"]',
      titre: "Les certifications",
      texte: "Vous retrouvez ici les parcours terminés et les attestations qui vont avec.",
      terminer: "J'ai compris",
    },
  ],
  en: [
    {
      cible: '[data-visite="admin-suivi"]',
      titre: "Who is moving forward, and who is not",
      texte: "Monitoring shows you where each learner stands. This is where you spot the ones to follow up.",
    },
    {
      cible: '[data-visite="admin-progression"]',
      titre: "Your group's skills",
      texte: "Mapping gives you the wider view: which skills are rising, which ones resist.",
    },
    {
      cible: '[data-visite="admin-certification"]',
      titre: "Certifications",
      texte: "Completed paths and the certificates that go with them.",
      terminer: "Got it",
    },
  ],
}

const MESSAGES_SANS_PERIMETRE = {
  aucuneEcole : {
    fr : "Votre compte n'est encore rattaché à aucune école. Écrivez-nous depuis le chat de support\u00a0: nous le configurons.",
    en : "Your account is not linked to any school yet. Write to us from the support chat and we will set it up.",
  },
  aucunGroupe : {
    fr : "Votre école n'a pas encore de groupe\u00a0: vos tableaux de bord apparaîtront dès le premier groupe créé. Une question\u00a0? Écrivez-nous depuis le chat de support.",
    en : "Your school does not have any group yet: your dashboards will appear as soon as the first group is created. Any question? Write to us from the support chat.",
  },
}

const AdminDashboard = () => {
  const navigate = useNavigate();

  const {
    actPage,
    actEcoleID,
    userLoaded,
    sansPerimetre,
  } = useContext(UserAdminClientContext)

  const { actLanguage } = useContext(LanguageContext)

  return (
    <>
      <Helmet>
        <title>Dashboard | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >

        {/* B50 (25/09/2026) : un admin client sans ecole, ou dont l'ecole n'a
            pas encore de groupe, voyait une page blanche. Le message ne s'affiche
            que lorsque le chargement a conclu (`sansPerimetre`), jamais pendant. */}
        {(userLoaded === true && sansPerimetre) &&
          <Box role="status" sx={{ maxWidth: "560px", margin: "80px auto", padding: "0 24px", textAlign: "center", fontSize: "18px", lineHeight: "160%", color: "text.primary" }}>
            {MESSAGES_SANS_PERIMETRE[sansPerimetre][actLanguage === "en" ? "en" : "fr"]}
          </Box>
        }

        {(userLoaded === true && actPage !== null && actEcoleID !== null) &&
          <>
            {actPage === "home" &&
              <Home />
            }
            {actPage === "suivi" &&
              <Suivi />
            }
            {actPage === "progression" &&
              <Progression />
            }
            {actPage === "certification" &&
              <Certification />
            }
          </>
        }


      </Box>

      {/* Chat de support disponible pour l'admin client depuis son espace,
          sans avoir a chercher un email. L'identite est reprise cote serveur
          via la session ; plateforme "lab" comme le reste de cet espace. */}
      <SupportChat plateforme="lab" />

      {/* Une fois par personne et par navigateur. Les etapes dont la cible
          n'existe pas sont sautees en silence. */}
      <VisiteGuidee
        cle={actEcoleID ? ("risingup.visite.adminclient." + actEcoleID) : null}
        etapes={ETAPES_ADMIN[actLanguage] || ETAPES_ADMIN.fr}
      />
    </>
  )
};

export default AdminDashboard;
